import React from 'react';

export default function IconSettingSupport() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_652_347)">
        <path
          d="M4.36833 7.25001C4.65417 4.94584 6.62 3.16667 9 3.16667C10.2892 3.16667 11.4558 3.69167 12.3017 4.53167C13.0133 5.24917 13.4975 6.19417 13.6317 7.25001"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.1667 13.515C11.6051 13.1464 12.7785 12.1085 13.3281 10.7522"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 7.25H4.91667V10.75H3.75C3.10834 10.75 2.58334 10.225 2.58334 9.58333V8.41667C2.58334 7.775 3.10834 7.25 3.75 7.25Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.25 10.75H13.0833V7.25H14.25C14.8917 7.25 15.4167 7.775 15.4167 8.41667V9.58333C15.4167 10.225 14.8917 10.75 14.25 10.75Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.125 13.3917H9.875C10.0269 13.3917 10.15 13.5148 10.15 13.6667C10.15 13.8185 10.0269 13.9417 9.875 13.9417H8.125C7.97312 13.9417 7.85 13.8185 7.85 13.6667C7.85 13.5148 7.97312 13.3917 8.125 13.3917Z"
          fill="#333333"
          stroke="currentColor"
          strokeWidth="1.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_652_347">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
